import { Loader } from '@googlemaps/js-api-loader';
import config from 'App/babel/config';

export const loader = new Loader({
	apiKey: config.GOOGLE_MAPS_KEY,
	version: 'quarterly',
	libraries: ['places', 'marker']
});
